import { Action } from '@ngrx/store';

export const GET_INSTITUTION_SUMMARY_TOTALS = '[Institution Summary] Get Institution Summary Totals';
export const GET_INSTITUTION_SUMMARY_TOTALS_SUCCESS = '[Institution Summary] Get Institution Summary Totals Success';
export const GET_INSTITUTION_SUMMARY_TOTALS_FAIL = '[Institution Summary] Get Institution Summary Totals Fail';
export const CLEAR_INSTITUTION_SUMMARY = '[Institution Summary] Clear Institution Summary';

export class GetInstitutionSummaryTotals implements Action {
    readonly type = GET_INSTITUTION_SUMMARY_TOTALS;
    constructor(public payload: any = null) { }
}

export class GetInstitutionSummaryTotalsSuccess implements Action {
    readonly type = GET_INSTITUTION_SUMMARY_TOTALS_SUCCESS;
    constructor(public payload: any = null) { }
}

export class GetInstitutionSummaryTotalsFail implements Action {
    readonly type = GET_INSTITUTION_SUMMARY_TOTALS_FAIL;
    constructor(public payload: any = null) { }
}

export class ClearInstitutionSummary implements Action {
    readonly type = CLEAR_INSTITUTION_SUMMARY;
}

export type InstitutionSummaryActions =
    | GetInstitutionSummaryTotals
    | GetInstitutionSummaryTotalsFail
    | GetInstitutionSummaryTotalsSuccess
    | ClearInstitutionSummary
    ;